// ==============================|| DEFAULT THEME - TYPOGRAPHY ||============================== //

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily: `'Inter', ${fontFamily}, sans-serif`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.2,
      letterSpacing: '-0.025em'
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.75rem',
      lineHeight: 1.25,
      letterSpacing: '-0.02em'
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.375rem',
      lineHeight: 1.3,
      letterSpacing: '-0.015em'
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.4,
      letterSpacing: '-0.01em'
    },
    h5: {
      fontWeight: 600,
      fontSize: '0.9375rem',
      lineHeight: 1.5,
      letterSpacing: '-0.005em'
    },
    h6: {
      fontWeight: 500,
      fontSize: '0.8125rem',
      lineHeight: 1.57
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66,
      letterSpacing: '0.01em'
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.6
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.66,
      color: 'inherit'
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.66,
      letterSpacing: '0.04em',
      textTransform: 'uppercase'
    },
    overline: {
      lineHeight: 1.66,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: '0.625rem'
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.01em'
    }
  };
}
